import { TextField } from '@mui/material';

const ProductDocumentToDistributeSearch = ({ setSearch }: { setSearch: (value: string) => void }) => {
  const handleSearch = (e: string) => {
    setSearch(e);
  };

  return (
    <TextField
      data-testid="product-document-to-distribute-search"
      label={'Search...'}
      sx={{
        m: 0.5,
        '& .MuiFormLabel-root': {
          top: -7,
        },
        input: {
          justifyContent: 'center',
          alignItems: 'center',
          padding: '0.2em',
          height: '2em',
          width: '100%',
          border: '1px solid #D9D9D9',
          borderRadius: '4px',
          backgroundColor: '#FFFFFF',
          color: '#000000',
          '&:hover': {
            border: '1px solid #D9D9D9',
          },
          '&:focus': {
            border: '1px solid #D9D9D9',
            '& .MuiFormLabel-root': {
              top: 0,
            },
          },
        },
        inputLabel: {
          mb: 1,
        },
      }}
      fullWidth
      onChange={(e) => handleSearch(e.target.value)}
    />
  );
};

export default ProductDocumentToDistributeSearch;
